import type { RootState } from '@reducers/index';
import { updateShippableOnly } from '@reducers/search';
import { useViewport } from '@sbt-web/hooks';
import { FormGroup, FormLabel, Toggle } from '@sbt-web/ui';
import { shippableOnlyLabel } from '@tools/search/values';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import NationwideSearchExpander from '../../SearchNationwide';
import commonClasses from '../SelectorStyles/common.module.scss';
import ownClasses from './shippable-only.module.scss';
import { FilterURI } from '@sbt-web/network/types';

interface StateProps {
  includeShippableOnly: boolean;
}

interface DispatchProps {
  updateShippableOnly: (includeShippableOnly: boolean) => void;
}

interface OwnProps {
  trackSearchConversion: () => void;
}

type Props = StateProps & DispatchProps & OwnProps;

const ShippableOnlyComponent: React.FC<Props> = ({
  includeShippableOnly,
  updateShippableOnly,
  trackSearchConversion,
}) => {
  const { isMobile } = useViewport();

  const handleSelection = useCallback(
    (isSelected: boolean) => {
      trackSearchConversion();
      updateShippableOnly(isSelected);
    },
    [updateShippableOnly, trackSearchConversion]
  );

  return (
    <FormGroup>
      <FormLabel>Spedizione</FormLabel>
      <Toggle
        name={FilterURI.ItemShippable}
        checked={includeShippableOnly}
        onInputChange={handleSelection}
        spaceBetweenElements
        classes={[ownClasses['close-label'], commonClasses['custom-toggle']]}
      >
        {shippableOnlyLabel}
      </Toggle>

      {isMobile ? (
        <NationwideSearchExpander id="filter-nationwide-search-expander" />
      ) : null}
    </FormGroup>
  );
};

const ShippableOnlySelector = connect<
  StateProps,
  DispatchProps,
  OwnProps,
  RootState
>(
  (state, ownProps) => ({
    includeShippableOnly: state.search.includeShippableOnly,
    trackSearchConversion: ownProps.trackSearchConversion,
  }),
  (dispatch) => ({
    updateShippableOnly: (isActive: boolean) =>
      dispatch(updateShippableOnly(isActive)),
  })
)(ShippableOnlyComponent);

export default ShippableOnlySelector;
export { ShippableOnlyComponent };
